/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Home_DesktopInputs */

const en_gc_home_desktop = /** @type {(inputs: Gc_Home_DesktopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get the desktop app`)
};

const zh_gc_home_desktop = /** @type {(inputs: Gc_Home_DesktopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下载桌面版`)
};

/**
* | output |
* | --- |
* | "Get the desktop app" |
*
* @param {Gc_Home_DesktopInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_home_desktop = /** @type {((inputs?: Gc_Home_DesktopInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Home_DesktopInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_home_desktop(inputs)
	return zh_gc_home_desktop(inputs)
});
export { gc_home_desktop as "gc.home.desktop" }